angular.module('picmonic-common').directive('factCharacter', [
  '$state',
  '$q',
  '$timeout',
  '$window',
  '$filter',
  function ($state, $q, $timeout, $window, $filter) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        fact: '=',
        character: '=',
        playerService: '=',
        size: '=',
        zoom: '=',
        forceZoom: '=?',
        preventZoom: '@?',
        noBlur: '=',
        doesBlink: '=',
        startBlink: '=',
        doesFade: '=',
        zIndex: '=',
        pulse: '=',
        visible: '=',
      },
      template:
        "<div class=\"fact-character\" ng-class=\"[{invisible: (fact && !visible) || (fact && playerService.audioElement && !(playerService.audioElement.paused || playerService.audioElement.currentTime >= fact.audio[playerService.audioMode].start)) , selected: character.selected, primary: character.is_primary, doesBlink: blink, fades: doesFade, slowzoom: slowZoom, bounce: bounce, cropping: cropping, hasGifs: hasGifs, 'animation_disabled': UserService.user.settings.disable_player_animations || playerService.location === 'quiz'}, playerService.mode != 'editor' || character.allow_animation ? character.animation : false, playerService.audioElement.paused ? 'viewed' : false]\" ng-style=\"maskStyles\">" +
        '<div class="character-tools-wrapper" ng-show="playerService.mode == \'editor\'">' +
        '<div class="resize-anchor top left"></div>' +
        '<div class="resize-anchor top right"></div>' +
        '<div class="resize-anchor bottom left"></div>' +
        '<div class="resize-anchor bottom right"></div>' +
        '<div class="rotate-anchor" ng-show="rotateVisible"><i class="material-icons">replay</i></div>' +
        '<div class="fact-editor-tools-wrapper">' +
        '<div class="fact-editor-tools" ng-show="!cropping && !lassoing">' +
        '<button class="fact-editor-tools--delete" ng-click="deleteCharacter()" tooltip="Delete" tooltip-append-to-body="true"><i class="material-icons md-middle">delete</i></button>' +
        '<button class="fact-editor-tools--edit" ng-show="character.name.indexOf(\'plstext\') > -1" ng-click="playerService.showTextCreator(character)" tooltip="Edit Text" tooltip-append-to-body="true"><i class="material-icons md-middle">edit</i></button>' +
        '<button class="fact-editor-tools--crop-button" ng-click="toggleCropping()" tooltip="Crop" tooltip-append-to-body="true"><i class="material-icons md-middle">crop</i></button>' +
        '<button class="fact-editor-tools--lasso" ng-click="lasso()" tooltip="Lasso Crop" tooltip-append-to-body="true"><i class="picmonic-icons md-middle">lasso</i></button>' +
        '<button class="fact-editor-tools--flip-horizontal" ng-click="flipHorizontal()" tooltip="Flip Horizontal" tooltip-append-to-body="true"><i class="material-icons md-middle">flip</i></button>' +
        '<button class="fact-editor-tools--flip-vertical" ng-click="flipVertical()" tooltip="Flip Vertical" tooltip-append-to-body="true"><i class="material-icons md-middle md-rotate-90">flip</i></button>' +
        '<button class="fact-editor-tools--move-down" ng-click="moveDown()" ng-if="character.character_z > lowestZ()" tooltip="Move Layer Down" tooltip-append-to-body="true"><i class="material-icons md-middle">keyboard_arrow_down</i></button>' +
        '<button class="fact-editor-tools--move-up" ng-click="moveUp()" ng-if="character.character_z < highestZ()" tooltip="Move Layer Up" tooltip-append-to-body="true"><i class="material-icons md-middle">keyboard_arrow_up</i></button>' +
        '</div>' +
        '<div class="fact-editor-tools" ng-show="lassoing">' +
        '<button class="fact-editor-tools--delete" ng-click="finishLasso()"><i class="material-icons md-middle">check</i></button>' +
        '<button class="fact-editor-tools--crop-button" ng-click="cancelLasso()"><i class="material-icons md-middle">close</i></button>' +
        '</div>' +
        '<div class="fact-editor-tools fact-editor-tools--crop" ng-show="cropping">' +
        '<button class="pls-btn" ng-click="toggleCropping()">Done</button>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '<div class="asset-mask">' +
        '<div class="asset-wrapper" ng-class="{mirrored_x: character.mirrored_x, mirrored_y: character.mirrored_y, \'animation_disabled\': UserService.user.settings.disable_player_animations || fact.prevent_zoom}" ng-style=characterStyles></div>' +
        '</div>' +
        '</div>',
      controller: [
        '$scope',
        '$filter',
        'UserService',
        function ($scope, $filter, UserService) {
          $scope.maskStyles = {};
          $scope.characterStyles = {};
          $scope.element = false;
          $scope.slowZoom = false;
          $scope.previouslyZoomed = false;
          $scope.cropping = false;
          $scope.UserService = UserService;
          $scope.viewed =
            $scope.fact && $scope.fact.learned_flag && $scope.playerService.mode !== 'editor' ? 'viewed' : '';

          $scope.isFactSelected = function () {
            return (
              $scope.playerService.location == 'quiz' ||
              $scope.fact.selected ||
              ($scope.fact.is_primary && $scope.playerService.tab == 'topic')
            );
          };

          function determineDimensions() {
            if (!$scope.container) {
              return;
            }
            var zoomPrevented = $scope.preventZoom == 1 || ($scope.fact && $scope.fact.prevent_zoom == 1);
            var zoomRequested =
              $scope.fact && $scope.isFactSelected() && ((window.innerWidth < 480 && $scope.zoom) || $scope.forceZoom);
            var doZoom = zoomPrevented == false && zoomRequested == true;

            if ($scope.fact && doZoom) {
              var minx;
              var miny;
              var maxx;
              var maxy;

              if ($scope.fact.characters.length > 0) {
                for (a in $scope.fact.characters) {
                  var character = $scope.fact.characters[a];

                  minx =
                    typeof minx != 'undefined'
                      ? character.character_x + character.crop_x < minx
                        ? character.character_x + character.crop_x
                        : minx
                      : character.character_x + character.crop_x;
                  miny =
                    typeof miny != 'undefined'
                      ? character.character_y + character.crop_y < miny
                        ? character.character_y + character.crop_y
                        : miny
                      : character.character_y + character.crop_y;
                  maxx =
                    typeof maxx != 'undefined'
                      ? character.character_x + character.crop_x + character.crop_width > maxx
                        ? character.character_x + character.crop_x + character.crop_width
                        : maxx
                      : character.character_x + character.crop_x + character.crop_width;
                  maxy =
                    typeof maxy != 'undefined'
                      ? character.character_y + character.crop_y + character.crop_height > maxy
                        ? character.character_y + character.crop_y + character.crop_height
                        : maxy
                      : character.character_y + character.crop_y + character.crop_height;
                }

                var boundingHeight = maxy - miny,
                  boundingWidth = maxx - minx,
                  containerWidth = $scope.container.width(),
                  containerHeight = $scope.container.height();

                var percentWidth = boundingWidth / 2200;
                var percentHeight = boundingHeight / 1700;
                $scope.maxPercent = percentWidth > percentHeight ? percentWidth : percentHeight;

                if ($scope.maxPercent >= 0.85) {
                  var maskStyles = {
                    width: $scope.character.crop_width
                      ? ($scope.character.crop_width / 2200) * 100 + '%'
                      : ($scope.character.character_width / 2200) * 100 + '%',
                    height: $scope.character.crop_height
                      ? ($scope.character.crop_height / 1700) * 100 + '%'
                      : ($scope.character.character_height / 1700) * 100 + '%',
                    left: $scope.character.crop_x
                      ? (($scope.character.crop_x + $scope.character.character_x) / 2200) * 100 + '%'
                      : ($scope.character.character_x / 2200) * 100 + '%',
                    top: $scope.character.crop_y
                      ? (($scope.character.crop_y + $scope.character.character_y) / 1700) * 100 + '%'
                      : ($scope.character.character_y / 1700) * 100 + '%',
                  };
                } else {
                  var left, top, ratio;

                  if (
                    boundingWidth > boundingHeight &&
                    (containerWidth / boundingWidth) * boundingHeight < containerHeight
                  ) {
                    ratio = containerWidth / boundingWidth;
                  } else {
                    ratio = containerHeight / boundingHeight;
                  }

                  if ($scope.maxPercent < 0.6) {
                    $scope.maxPercent = 0.6;
                  }

                  top = (containerHeight - boundingHeight * ratio * $scope.maxPercent) / 2;
                  left = (containerWidth - boundingWidth * ratio * $scope.maxPercent) / 2;

                  var maskStyles = {
                    width: (($scope.character.crop_width * ratio) / containerWidth) * $scope.maxPercent * 100 + '%',
                    height: (($scope.character.crop_height * ratio) / containerHeight) * $scope.maxPercent * 100 + '%',
                    left:
                      ((($scope.character.character_x + $scope.character.crop_x - minx) * ratio + left) /
                        containerWidth) *
                        100 +
                      '%',
                    top:
                      ((($scope.character.character_y + $scope.character.crop_y - miny) * ratio + top) /
                        containerHeight) *
                        100 +
                      '%',
                  };

                  $scope.previouslyZoomed = true;
                }
              }
            } else {
              if ($scope.previouslyZoomed) {
                $scope.previouslyZoomed = false;
                if ($scope.playerService.location == 'quiz') {
                  $scope.slowZoom = true;
                }
              } else if ($scope.slowZoom) {
                $scope.slowZoom = false;
              }

              var maskStyles = {
                width: $scope.character.crop_width
                  ? ($scope.character.crop_width / 2200) * 100 + '%'
                  : ($scope.character.character_width / 2200) * 100 + '%',
                height: $scope.character.crop_height
                  ? ($scope.character.crop_height / 1700) * 100 + '%'
                  : ($scope.character.character_height / 1700) * 100 + '%',
                left: $scope.character.crop_x
                  ? (($scope.character.crop_x + $scope.character.character_x) / 2200) * 100 + '%'
                  : ($scope.character.character_x / 2200) * 100 + '%',
                top: $scope.character.crop_y
                  ? (($scope.character.crop_y + $scope.character.character_y) / 1700) * 100 + '%'
                  : ($scope.character.character_y / 1700) * 100 + '%',
              };
            }

            var styles = {
              'width': $scope.character.crop_width
                ? ($scope.character.character_width / $scope.character.crop_width) * 100 + '%'
                : '100%',
              'height': $scope.character.crop_height
                ? ($scope.character.character_height / $scope.character.crop_height) * 100 + '%'
                : '100%',
              'left': $scope.character.crop_x
                ? ($scope.character.crop_x / $scope.character.crop_width) * -100 + '%'
                : '0%',
              'top': $scope.character.crop_y
                ? ($scope.character.crop_y / $scope.character.crop_height) * -100 + '%'
                : '0%',
              'z-index': $scope.character.character_z ? $scope.character.character_z : '',
            };

            if ($scope.zIndex) {
              styles.zIndex = $scope.zIndex;
            }

            if (
              ($scope.playerService.mode == 'review' &&
                $scope.playerService.reviewStep == 1 &&
                !$scope.playerService.modalInstance) ||
              ($scope.playerService.showBlur && !$scope.noBlur)
            ) {
              var quizBlur = 15;
              styles['-webkit-filter'] = 'blur(' + quizBlur + 'px)';
              styles['-moz-filter'] = 'blur(' + quizBlur + 'px)';
              styles['-o-filter'] = 'blur(' + quizBlur + 'px)';
              styles['-ms-filter'] = 'blur(' + quizBlur + 'px)';
              styles['filter'] = 'blur(' + quizBlur + 'px)';
            }

            $scope.maskStyles = maskStyles;
            $scope.characterStyles = styles;

            return styles;
          }

          determineDimensions();

          if ($scope.fact) {
            $scope.$watch(
              function () {
                return $scope.fact.selected;
              },
              function (value) {
                if (value != undefined) {
                  $timeout(determineDimensions, 0);
                }
              }
            );
          }

          $scope.$watch(
            function () {
              return $scope.playerService.showBlur;
            },
            function (value) {
              if (value != undefined) {
                $timeout(determineDimensions, 0);
              }
            }
          );

          $scope.$watch(
            function () {
              return $scope.zoom || $scope.forceZoom ? true : false;
            },
            function (value) {
              if (value != undefined) {
                $timeout(determineDimensions, 0);
              }
            }
          );

          if ($scope.playerService.reviewStep) {
            $scope.$watch(
              function () {
                return $scope.playerService.reviewStep;
              },
              function (value) {
                if (value == 2 && $scope.fact && $scope.fact.selected) {
                  $timeout(determineDimensions, 0);
                }
              }
            );
          }

          $scope.$watch(
            function () {
              return $scope.playerService.modalInstance;
            },
            function (value) {
              $timeout(determineDimensions, 0);
            }
          );

          $scope.$watch(
            function () {
              return $scope.playerService.mode;
            },
            function (value) {
              if (value != undefined) {
                $timeout(determineDimensions, 0);
              }
            }
          );

          $scope.$watch(
            function () {
              return $scope.character.selected;
            },
            function () {
              if (!$scope.character.selected && $scope.cropping) {
                $scope.cropping = false;
              }
              if (!$scope.character.selected && $scope.lassoing) {
                $scope.cancelLasso();
              }
            }
          );

          /**
           * Watching character.character_z for moveUp/moveDown digest cycle
           * trigger to update all the other placed characters z-index.
           */
          $scope.$watch('character.character_z', function () {
            determineDimensions();
          });

          angular.element($window).resize(determineDimensions);

          $scope.deleteCharacter = function () {
            var characterPos = $scope.fact.characters.indexOf($scope.character);

            if (!$scope.character.card_fact_character_id) {
              $scope.fact.characters = _.without($scope.fact.characters, $scope.character);
            } else {
              $scope.character.deleted = true;
            }

            var remainingFacts = $filter('filter')($scope.fact.characters, {
              deleted: '!true',
            });

            if (!remainingFacts.length) {
              delete $scope.fact.hotspot_x;
              delete $scope.fact.hotspot_y;
            } else if (characterPos == 0) {
              $scope.fact.hotspot_x = remainingFacts[0].character_x + remainingFacts[0].character_width / 2;
              $scope.fact.hotspot_y = remainingFacts[0].character_y + remainingFacts[0].character_height / 2;
            }
            $scope.playerService.addToHistory();
          };

          $scope.moveDown = function () {
            if ($scope.character.character_z - 1 >= $scope.lowestZ()) {
              var nextLowestCharacter = $scope.nextLowestCharacter();
              $scope.character.character_z = nextLowestCharacter.character_z;
              nextLowestCharacter.character_z++;
              $scope.playerService.addToHistory();
              $timeout($scope.determineToolPosition, 0);
            }
          };

          $scope.moveUp = function () {
            if ($scope.character.character_z + 1 <= $scope.highestZ()) {
              var nextHighestCharacter = $scope.nextHighestCharacter();
              $scope.character.character_z = nextHighestCharacter.character_z;
              nextHighestCharacter.character_z--;
              $scope.playerService.addToHistory();
              $timeout($scope.determineToolPosition, 0);
            }
          };

          $scope.lowestZ = function () {
            if ($scope.playerService.mode == 'editor') {
              var lowestZ,
                facts = $scope.playerService.currentFacts,
                fact,
                character;

              for (var a in facts) {
                fact = facts[a];

                for (var b in fact.characters) {
                  character = fact.characters[b];

                  if (!character.deleted && (!lowestZ || character.character_z < lowestZ)) {
                    lowestZ = character.character_z;
                  }
                }
              }

              return lowestZ;
            }
          };

          $scope.highestZ = function () {
            if ($scope.playerService.mode == 'editor') {
              var highestZ,
                facts = $scope.playerService.currentFacts,
                fact,
                character;

              for (var a in facts) {
                fact = facts[a];

                for (var b in fact.characters) {
                  character = fact.characters[b];

                  if (!character.deleted && (!highestZ || character.character_z > highestZ)) {
                    highestZ = character.character_z;
                  }
                }
              }

              return highestZ;
            }
          };

          $scope.nextHighestCharacter = function () {
            var facts = $scope.playerService.currentFacts,
              fact,
              characters = [];

            for (var a in facts) {
              fact = facts[a];

              for (var b in fact.characters) {
                if (!fact.characters[b].deleted) {
                  characters.push(fact.characters[b]);
                }
              }
            }

            characters = $filter('orderBy')(characters, 'character_z');

            return characters[$filter('arrayPos')(characters, $scope.character.character_z, 'character_z') + 1];
          };

          $scope.nextLowestCharacter = function () {
            var facts = $scope.playerService.currentFacts,
              fact,
              characters = [];

            for (var a in facts) {
              fact = facts[a];

              for (var b in fact.characters) {
                if (!fact.characters[b].deleted) {
                  characters.push(fact.characters[b]);
                }
              }
            }

            characters = $filter('orderBy')(characters, 'character_z');

            return characters[$filter('arrayPos')(characters, $scope.character.character_z, 'character_z') - 1];
          };

          //Horizontal Flip requires that the char+x be offset by the width/crop_width diff in
          //either a positive or negitive direction depending on if flip is true or false
          $scope.flipHorizontal = function () {
            var originalCropX = $scope.character.crop_x;
            var originalCharacterX = $scope.character.character_x;
            var xOffset =
              originalCropX - ($scope.character.character_width - (originalCropX + $scope.character.crop_width));

            $scope.character.character_x += xOffset;
            $scope.character.mirrored_y = !$scope.character.mirrored_y;
            $scope.character.crop_x =
              $scope.character.character_width - ($scope.character.crop_x + $scope.character.crop_width);
            determineDimensions();
            $scope.playerService.addToHistory();
          };

          //Vertical Flip requires that the char+y be offset by the height/crop_height diff in
          //either a positive or negitive direction depending on if flip is true or false
          $scope.flipVertical = function () {
            var originalCropY = $scope.character.crop_y;
            var yOffset =
              originalCropY - ($scope.character.character_height - (originalCropY + $scope.character.crop_height));

            $scope.character.character_y += yOffset;
            $scope.character.mirrored_x = !$scope.character.mirrored_x;
            $scope.character.crop_y =
              $scope.character.character_height - ($scope.character.crop_y + $scope.character.crop_height);
            determineDimensions();
            $scope.playerService.addToHistory();
          };

          $scope.toggleCropping = function () {
            if (!$scope.cropping) {
              angular.element('body').on('keypress', $scope.toggleCroppingOnEnter);
            } else {
              angular.element('body').off('keypress', $scope.toggleCroppingOnEnter);
            }

            $scope.cropping = !$scope.cropping;
          };

          $scope.toggleCroppingOnEnter = function (event) {
            if (event.charCode === 13) {
              $scope.$apply(function () {
                $scope.toggleCropping();
              });
            }
          };
        },
      ],

      link: function (scope, element, attrs) {
        var sizeSuffix = '';

        if (window.innerWidth < 480) {
          scope.size = 'sm';
        }

        switch (scope.size) {
          case 'md':
            sizeSuffix = '_threequarter';
            break;
          case 'sm':
            sizeSuffix = '_half';
            break;
          case 'xs':
            sizeSuffix = '_quarter';
            break;
        }

        if (scope.playerService.getSlowSpeedMode && scope.playerService.getSlowSpeedMode()) {
          sizeSuffix = '_quarter';
        }

        var container = (scope.container = element.parents('.learn-image-wrapper'));

        // Handle blink
        if (scope.doesBlink) {
          scope.$watch(
            function () {
              return scope.startBlink;
            },
            function (value) {
              if (value) {
                if (
                  scope.UserService.user.user_id &&
                  (scope.UserService.user.settings.disable_quiz_animations ||
                    scope.UserService.user.settings.slow_connection_mode)
                ) {
                  $timeout(function () {
                    scope.playerService.animationDone = true;
                  }, 1000);
                } else {
                  $timeout(function () {
                    scope.playerService.animationDone = false;
                    $timeout(function () {
                      $timeout(function () {
                        scope.bounce = false;
                        scope.forceZoom = false;
                        $timeout(function () {
                          scope.playerService.animationDone = true;
                        }, 1000);
                      }, 1000);

                      if (scope.maxPercent < 0.85) {
                        scope.bounce = true;
                      }
                      element.addClass('bounce-quiz');
                    }, 500);
                  }, 750);
                }
              }
            }
          );
        }
        for (var a in scope.character.assets) {
          var asset = scope.character.assets[a];

          if (!scope.hasGifs && asset.image_url && asset.image_url.indexOf('.gif') === asset.image_url.length - 4) {
            scope.hasGifs = true;
          }

          if (asset.img && asset.img.src.indexOf('data:') === 0) {
            asset.img = asset.img.cloneNode();
            element.find('.asset-wrapper').append(asset.img);
            determineToolPosition();
          } else if (asset.image_url) {
            var assetStatus = $q(function (resolve, reject) {
              var img = new Image();
              asset.img = img;
              if (scope.pulse) {
                img.className = 'character-pulse';
              }
              img.addEventListener('load', function () {
                element.find('.asset-wrapper').append(img);
                determineToolPosition();
                resolve();
                scope.$apply(function () {
                  scope.rotateVisible = true;
                });
              });

              img.addEventListener('error', function (e) {
                reject();
              });

              if (scope.playerService.mode == 'editor') {
                img.crossOrigin = 'anonymous';
                img.src = asset.image_url.replace('picmonic_assets', 'picmonic_assets' + sizeSuffix) + '?_';
              } else {
                img.src = asset.image_url.replace('picmonic_assets', 'picmonic_assets' + sizeSuffix);
              }

              img.style.width = (asset.width / scope.character.original_width) * 100 + '%';
              img.style.height = (asset.height / scope.character.original_height) * 100 + '%';
              img.style.left = (asset.x / scope.character.original_width) * 100 + '%';
              img.style.top = (asset.y / scope.character.original_height) * 100 + '%';
              img.style['z-index'] = asset.z;
            });

            scope.playerService.assetStatus.push(assetStatus);
          }
        }

        if (scope.fact) {
          if (
            scope.playerService.mode == 'editor' &&
            ((scope.fact.is_primary && scope.playerService.hasAccess('workflow', 'topic_character', scope.fact)) ||
              (!scope.fact.is_primary && scope.playerService.hasAccess('workflow', 'fact_character', scope.fact)))
          ) {
            var prevx,
              prevy,
              selectedAnchor,
              originalValues,
              rotation = 0,
              origin,
              mouseOffset,
              action;

            var getDistanceMoved = function (e, ratio) {
              var ratiox = 2200 / container.width();
              var ratioy = 1700 / container.height();

              var moved = {
                x: (e.pageX - prevx) * ratiox,
                y: (e.pageY - prevy) * ratioy,
              };

              prevx = e.pageX;
              prevy = e.pageY;

              return moved;
            };

            var moveHandler = function (e) {
              if (action === 'rotate' || scope.lassoing) {
                return;
              }
              var moved = getDistanceMoved(e);

              var new_x = Math.max(
                Math.min(
                  originalValues.character_x + originalValues.crop_x + moved.x,
                  2200 - originalValues.crop_width
                ),
                0
              );
              var new_y = Math.max(
                Math.min(
                  originalValues.character_y + originalValues.crop_y + moved.y,
                  1700 - originalValues.crop_height
                ),
                0
              );

              if (
                $filter('filter')(scope.fact.characters, {
                  deleted: '!true',
                }).indexOf(scope.character) === 0
              ) {
                if (originalValues.character_x != new_x - originalValues.crop_x) {
                  originalValues.hotspot_x += moved.x;
                }
                if (originalValues.character_y != new_y - originalValues.crop_y) {
                  originalValues.hotspot_y += moved.y;
                }
              }

              originalValues.character_x = new_x - originalValues.crop_x;
              originalValues.character_y = new_y - originalValues.crop_y;

              applyNewStyles();
            };

            var rotateHandler = function (e) {
              e.stopPropagation();
              rotation =
                ((Math.atan2(-(element[0].offsetHeight / 2 + 21), 0) -
                  Math.atan2(origin.y - e.pageY + mouseOffset.y, e.pageX - mouseOffset.x - origin.x)) *
                  180) /
                Math.PI; //Math.atan2(origin.y - e.pageY + mouseOffset.y  + (element[0].offsetHeight/2 + 21), e.pageX - mouseOffset.x - origin.x) * 180 / Math.PI;
              element[0].style.transform = 'rotate(' + rotation + 'deg)';
            };

            var resizeHandler = function (e) {
              e.stopPropagation();

              var anchor = angular.element(selectedAnchor);
              var moved = getDistanceMoved(e, originalValues.crop_width / originalValues.crop_height);

              if (scope.cropping) {
                if (anchor.hasClass('left')) {
                  var new_x = Math.max(
                    Math.min(originalValues.crop_x + moved.x, originalValues.character_width - 25),
                    0
                  );
                  var updatedCropWidth = originalValues.crop_width - (new_x - originalValues.crop_x);
                  originalValues.crop_width = updatedCropWidth > 0 ? updatedCropWidth : originalValues.crop_width;
                  originalValues.crop_x = new_x;
                } else {
                  originalValues.crop_width = Math.max(
                    Math.min(
                      originalValues.crop_width + moved.x,
                      originalValues.character_width - originalValues.crop_x
                    ),
                    25
                  );
                }

                if (anchor.hasClass('top')) {
                  var new_y = Math.max(
                    Math.min(originalValues.crop_y + moved.y, originalValues.character_height - 25),
                    0
                  );
                  var updateCropHeight = originalValues.crop_height - (new_y - originalValues.crop_y);
                  originalValues.crop_height = updateCropHeight > 0 ? updateCropHeight : originalValues.crop_height;
                  originalValues.crop_y = new_y;
                } else {
                  originalValues.crop_height = Math.max(
                    Math.min(
                      originalValues.crop_height + moved.y,
                      originalValues.character_height - originalValues.crop_y
                    ),
                    25
                  );
                }

                if (scope.fact.characters.indexOf(scope.character) == 0) {
                  if (originalValues.character_x + originalValues.crop_x > originalValues.hotspot_x) {
                    originalValues.hotspot_x = originalValues.character_x + originalValues.crop_x;
                  } else if (
                    originalValues.character_x + originalValues.crop_x + originalValues.crop_width <
                    originalValues.hotspot_x
                  ) {
                    originalValues.hotspot_x =
                      originalValues.character_x + originalValues.crop_x + originalValues.crop_width;
                  }

                  if (originalValues.character_y + originalValues.crop_y > originalValues.hotspot_y) {
                    originalValues.hotspot_y = originalValues.character_y + originalValues.crop_y;
                  } else if (
                    originalValues.character_y + originalValues.crop_y + originalValues.crop_height <
                    originalValues.hotspot_y
                  ) {
                    originalValues.hotspot_y =
                      originalValues.character_y + originalValues.crop_y + originalValues.crop_height;
                  }
                }
              } else {
                var hotspot_x_ratio =
                  (originalValues.hotspot_x - (originalValues.character_x + originalValues.crop_x)) /
                  originalValues.crop_width;
                var hotspot_y_ratio =
                  (originalValues.hotspot_y - (originalValues.character_y + originalValues.crop_y)) /
                  originalValues.crop_height;

                if (anchor.hasClass('left')) {
                  moved.x = Math.min(moved.x, originalValues.crop_width - 25);
                  var ratio = moved.x / originalValues.crop_width;
                  originalValues.character_x += originalValues.crop_x * ratio + moved.x;
                  originalValues.character_width -= originalValues.character_width * ratio;
                  originalValues.crop_x -= originalValues.crop_x * ratio;
                  originalValues.crop_width -= originalValues.crop_width * ratio;
                } else {
                  moved.x = Math.max(moved.x, -originalValues.crop_width + 25);
                  var ratio = moved.x / originalValues.crop_width;
                  originalValues.character_x -= originalValues.crop_x * ratio;
                  originalValues.character_width += originalValues.character_width * ratio;
                  originalValues.crop_x += originalValues.crop_x * ratio;
                  originalValues.crop_width += originalValues.crop_width * ratio;
                }

                if (anchor.hasClass('top')) {
                  moved.y = Math.min(moved.y, originalValues.crop_height - 25);
                  var ratio = moved.y / originalValues.crop_height;
                  originalValues.character_y += originalValues.crop_y * ratio + moved.y;
                  originalValues.character_height -= originalValues.character_height * ratio;
                  originalValues.crop_y -= originalValues.crop_y * ratio;
                  originalValues.crop_height -= originalValues.crop_height * ratio;
                } else {
                  moved.y = Math.max(moved.y, -originalValues.crop_height + 25);
                  var ratio = moved.y / originalValues.crop_height;
                  originalValues.character_y -= originalValues.crop_y * ratio;
                  originalValues.character_height += originalValues.character_height * ratio;
                  originalValues.crop_y += originalValues.crop_y * ratio;
                  originalValues.crop_height += originalValues.crop_height * ratio;
                }

                if (scope.fact.characters.indexOf(scope.character) == 0) {
                  originalValues.hotspot_x =
                    originalValues.character_x + originalValues.crop_x + originalValues.crop_width * hotspot_x_ratio;
                  originalValues.hotspot_y =
                    originalValues.character_y + originalValues.crop_y + originalValues.crop_height * hotspot_y_ratio;
                }
              }

              applyNewStyles();
            };

            var applyNewStyles = function () {
              var maskStyles = {
                width: originalValues.crop_width
                  ? (originalValues.crop_width / 2200) * 100 + '%'
                  : (originalValues.character_width / 2200) * 100 + '%',
                height: originalValues.crop_height
                  ? (originalValues.crop_height / 1700) * 100 + '%'
                  : (originalValues.character_height / 1700) * 100 + '%',
                left: originalValues.crop_x
                  ? ((originalValues.crop_x + originalValues.character_x) / 2200) * 100 + '%'
                  : (originalValues.character_x / 2200) * 100 + '%',
                top: originalValues.crop_y
                  ? ((originalValues.crop_y + originalValues.character_y) / 1700) * 100 + '%'
                  : (originalValues.character_y / 1700) * 100 + '%',
              };

              var styles = {
                'width': originalValues.crop_width
                  ? (originalValues.character_width / originalValues.crop_width) * 100 + '%'
                  : '100%',
                'height': originalValues.crop_height
                  ? (originalValues.character_height / originalValues.crop_height) * 100 + '%'
                  : '100%',
                'left': originalValues.crop_x ? (originalValues.crop_x / originalValues.crop_width) * -100 + '%' : '0%',
                'top': originalValues.crop_y ? (originalValues.crop_y / originalValues.crop_height) * -100 + '%' : '0%',
                'z-index': scope.character.character_z ? scope.character.character_z : '',
              };

              element.css(maskStyles);
              element.find('.asset-wrapper').css(styles);

              if (scope.isFactSelected()) {
                angular.element('.learn-hotspot').css({
                  top: 'calc(' + (originalValues.hotspot_y / 1700) * 100 + '% - 10px)',
                  left: 'calc(' + (originalValues.hotspot_x / 2200) * 100 + '% - 10px)',
                });
              }

              determineToolPosition();
            };

            scope.lasso = function () {
              scope.lassoing = true;

              var canvas = document.createElement('CANVAS');
              canvas.height = scope.character.original_height;
              canvas.width = scope.character.original_width;
              canvas.id = 'lasso-canvas';
              element.find('.asset-wrapper').append(canvas);
              var ctx = canvas.getContext('2d');

              scope.lassoCanvas = new fabric.Canvas(canvas.id, {
                isDrawingMode: true,
              });
              scope.lassoCanvas.setDimensions({ width: '100%', height: '100%' }, { cssOnly: true });

              scope.lassoCanvas.freeDrawingBrush.color = '#ff8a0d';
              scope.lassoCanvas.freeDrawingBrush.width = 10;

              scope.lassoCanvas.on('path:created', function (options) {
                scope.lassoCanvas.isDrawingMode = false;
                scope.lassoPath = options.path;
              });
            };

            scope.cancelLasso = function () {
              scope.lassoCanvas.dispose();
              element.find('canvas').remove();
              scope.lassoing = false;
            };

            scope.finishLasso = function () {
              scope.lassoCanvas.remove(scope.lassoPath);
              scope.lassoCanvas.clipPath = new fabric.Path(scope.lassoPath.path);

              var orderedAssets = $filter('orderBy')(scope.character.assets, 'z');
              angular.forEach(orderedAssets, function (asset) {
                var imgInstance = new fabric.Image(asset.img, {
                  left: asset.x,
                  top: asset.y,
                  flipX: !!scope.character.mirrored_y,
                  flipY: !!scope.character.mirrored_x,
                });
                scope.lassoCanvas.add(imgInstance);
              });

              var canvas = scope.lassoCanvas.toCanvasElement();
              var context = canvas.getContext('2d');

              var trimmed = trim(canvas);
              var img = new Image();
              img.src = trimmed.canvas.toDataURL();
              scope.lassoCanvas.dispose();
              img.style.top = '0%';
              img.style.left = '0%';
              img.style.height = '100%';
              img.style.width = '100%';
              element.find('img').remove();
              element.find('canvas').remove();
              element.find('.asset-wrapper').append(img);
              scope.lassoing = false;
              scope.character.image_data = img.src;
              delete scope.character.hal;
              scope.character.assets = [
                {
                  height: trimmed.canvas.height,
                  width: trimmed.canvas.width,
                  x: 0,
                  y: 0,
                  z: 1,
                  img: img,
                },
              ];

              var scale_x = originalValues.character_width / scope.character.original_width;
              var scale_y = originalValues.character_height / scope.character.original_height;

              originalValues.original_width = trimmed.canvas.width;
              originalValues.original_height = trimmed.canvas.height;
              originalValues.character_width = originalValues.crop_width = trimmed.canvas.width * scale_x;
              originalValues.character_height = originalValues.crop_height = trimmed.canvas.height * scale_y;
              originalValues.character_x = originalValues.character_x + trimmed.left * scale_x;
              originalValues.character_y = originalValues.character_y + trimmed.top * scale_y;
              originalValues.crop_x = originalValues.crop_y = 0;
              originalValues.mirrored_x = originalValues.mirrored_y = null;
              originalValues.hotspot_x = originalValues.character_x + originalValues.character_width / 2;
              originalValues.hotspot_y = originalValues.character_y + originalValues.character_height / 2;

              for (var a in originalValues) {
                if (a == 'hotspot_x' || a == 'hotspot_y') {
                  if (scope.fact[a] != originalValues[a]) {
                    scope.fact[a] = originalValues[a];
                  }
                } else if (scope.character[a] != originalValues[a]) {
                  scope.character[a] = originalValues[a];
                }
              }
              scope.playerService.addToHistory();
              applyNewStyles();
            };

            var updateHandler = function (e) {
              //delete selectedAnchor;
              if (action === 'rotate') {
                var canvas = document.createElement('canvas');
                var o = (rotation * Math.PI) / 180;
                var learncontainerstyles = getComputedStyle(container[0]);
                var learncontainer = {
                  width: parseFloat(learncontainerstyles.width),
                  height: parseFloat(learncontainerstyles.height),
                };
                var character = scope.character;
                var scale = {
                  x: learncontainer.width / 2200,
                  y: learncontainer.height / 1700,
                };
                var x = character.crop_width * scale.x;
                var y = character.crop_height * scale.y;

                canvas.width = ((Math.abs(x * Math.cos(o)) + Math.abs(y * Math.sin(o))) * 2200) / learncontainer.width;
                canvas.height =
                  ((Math.abs(y * Math.cos(o)) + Math.abs(x * Math.sin(o))) * 1700) / learncontainer.height;

                var context = canvas.getContext('2d');
                context.scale(2200 / learncontainer.width, 1700 / learncontainer.height);
                context.translate(
                  (Math.abs(x * Math.cos(o)) + Math.abs(y * Math.sin(o))) / 2,
                  (Math.abs(y * Math.cos(o)) + Math.abs(x * Math.sin(o))) / 2
                );
                context.rotate(o);

                if (scope.character.mirrored_x) {
                  context.scale(1, -1);
                  var originalCropY = character.crop_y;
                  var yOffset = originalCropY - (character.character_height - (originalCropY + character.crop_height));

                  character.character_y += yOffset;
                  character.crop_y = character.character_height - (character.crop_y + character.crop_height);
                }
                if (scope.character.mirrored_y) {
                  context.scale(-1, 1);
                  var originalCropX = character.crop_x;
                  var originalCharacterX = character.character_x;
                  var xOffset = originalCropX - (character.character_width - (originalCropX + character.crop_width));

                  character.character_x += xOffset;
                  character.crop_x = character.character_width - (character.crop_x + character.crop_width);
                }

                var characterScale = {
                  x: character.character_width / character.original_width,
                  y: character.character_height / character.original_height,
                };
                var inverseCharacterScale = {
                  x: 1 / characterScale.x,
                  y: 1 / characterScale.y,
                };
                var orderedAssets = $filter('orderBy')(scope.character.assets, 'z');
                angular.forEach(orderedAssets, function (asset) {
                  var rect = {
                    left: asset.x * characterScale.x * scale.x,
                    top: asset.y * characterScale.y * scale.y,
                    width: asset.width * characterScale.x * scale.x,
                    height: asset.height * characterScale.y * scale.y,
                    x: character.crop_x * scale.x,
                    y: character.crop_y * scale.y,
                  };

                  var left = -scope.character.crop_x * inverseCharacterScale.x + asset.x;
                  var top = -scope.character.crop_y * inverseCharacterScale.y + asset.y;
                  var sx = left < 0 ? -left : 0;
                  var sy = top < 0 ? -top : 0;
                  var swidth = Math.min(
                    scope.character.crop_width * inverseCharacterScale.x,
                    asset.width - sx,
                    scope.character.crop_width * inverseCharacterScale.x - left
                  );
                  var sheight = Math.min(
                    scope.character.crop_height * inverseCharacterScale.y,
                    asset.height - sy,
                    scope.character.crop_height * inverseCharacterScale.y - top
                  );
                  var dx = -x / 2 + (left < 0 ? 0 : rect.left - rect.x);
                  var dy = -y / 2 + (top < 0 ? 0 : rect.top - rect.y);
                  var dwidth = Math.min(
                    x,
                    rect.width + (left < 0 ? -rect.x + rect.left : 0),
                    x - (-rect.x + rect.left)
                  );
                  var dheight = Math.min(y, rect.height + (top < 0 ? -rect.y + rect.top : 0), y - (-rect.y + rect.top));

                  context.drawImage(
                    asset.img,
                    sx, //sx
                    sy, //sy
                    swidth, //swidth
                    sheight, //sheight
                    dx, //dx
                    dy, //dy
                    dwidth, //dwidth
                    dheight //dheight
                  );
                });

                var trimmed = trim(canvas);
                var img = new Image();
                img.src = trimmed.canvas.toDataURL();
                img.style.top = '0%';
                img.style.left = '0%';
                img.style.height = '100%';
                img.style.width = '100%';
                element.find('img').remove();
                element.find('.asset-wrapper').append(img);

                originalValues.character_width =
                  originalValues.original_width =
                  originalValues.crop_width =
                    trimmed.canvas.width;
                originalValues.character_height =
                  originalValues.original_height =
                  originalValues.crop_height =
                    trimmed.canvas.height;
                originalValues.character_x -=
                  (canvas.width - (x * 2200) / container.width()) / 2 - trimmed.left - originalValues.crop_x;
                originalValues.character_y -=
                  (canvas.height - (y * 1700) / container.height()) / 2 - trimmed.top - originalValues.crop_y;
                originalValues.crop_x = originalValues.crop_y = 0;
                originalValues.mirrored_x = originalValues.mirrored_y = null;

                rotation = 0;
                scope.character.image_data = img.src;
                scope.character.assets = [
                  {
                    height: trimmed.canvas.height,
                    width: trimmed.canvas.width,
                    x: 0,
                    y: 0,
                    z: 1,
                    img: img,
                  },
                ];
                delete scope.character.hal;
                element[0].style.transform = 'none';
                element[0].style.zIndex = 'auto';
                applyNewStyles();
              }
              action = false;
              angular.element('body').unbind('mousemove', moveHandler);
              angular.element('body').unbind('mousemove', resizeHandler);
              angular.element('body').unbind('mousemove', rotateHandler);
              angular.element('body').unbind('mouseup', updateHandler);

              var dataUpdated = false;

              for (var a in originalValues) {
                if (a == 'hotspot_x' || a == 'hotspot_y') {
                  if (scope.fact[a] != originalValues[a]) {
                    scope.fact[a] = originalValues[a];
                    dataUpdated = true;
                  }
                } else if (scope.character[a] != originalValues[a]) {
                  scope.character[a] = originalValues[a];
                  dataUpdated = true;
                }
              }

              if (dataUpdated) {
                scope.playerService.addToHistory();
              }

              if (!element.has(angular.element(e.target)).length) {
                scope.character.selected = false;
              }

              scope.$apply();
            };

            var trim = function (c) {
              var ctx = c.getContext('2d'),
                copy = document.createElement('canvas').getContext('2d'),
                pixels = ctx.getImageData(0, 0, c.width, c.height),
                l = pixels.data.length,
                i,
                bound = {
                  top: null,
                  left: null,
                  right: null,
                  bottom: null,
                },
                x,
                y;

              for (i = 0; i < l; i += 4) {
                if (pixels.data[i + 3] !== 0) {
                  x = (i / 4) % c.width;
                  y = ~~(i / 4 / c.width);

                  if (bound.top === null) {
                    bound.top = y;
                  }

                  if (bound.left === null) {
                    bound.left = x;
                  } else if (x < bound.left) {
                    bound.left = x;
                  }

                  if (bound.right === null) {
                    bound.right = x;
                  } else if (bound.right < x) {
                    bound.right = x;
                  }

                  if (bound.bottom === null) {
                    bound.bottom = y;
                  } else if (bound.bottom < y) {
                    bound.bottom = y;
                  }
                }
              }

              var trimHeight = bound.bottom - bound.top + 1,
                trimWidth = bound.right - bound.left + 1,
                trimmed = ctx.getImageData(bound.left, bound.top, trimWidth, trimHeight);

              copy.canvas.width = trimWidth;
              copy.canvas.height = trimHeight;
              copy.putImageData(trimmed, 0, 0);

              // open new window with trimmed image:
              return { canvas: copy.canvas, top: bound.top, left: bound.left };
            };

            element.bind('mousedown', function (e) {
              prevx = e.pageX;
              prevy = e.pageY;

              originalValues = {
                character_x: scope.character.character_x,
                character_y: scope.character.character_y,
                character_width: scope.character.character_width,
                character_height: scope.character.character_height,
                hotspot_x: scope.fact.hotspot_x,
                hotspot_y: scope.fact.hotspot_y,
                crop_x: scope.character.crop_x,
                crop_y: scope.character.crop_y,
                crop_width: scope.character.crop_width,
                crop_height: scope.character.crop_height,
              };

              scope.$apply(function () {
                scope.playerService.selectCharacter(scope.character);
              });

              angular.element('body').bind('mousemove', moveHandler).bind('mouseup', updateHandler);
            });

            angular.element('body').bind('keydown', function (e) {
              switch (e.keyCode) {
                case 8:
                  if (
                    !angular.element(e.target).is('input, textarea') &&
                    !angular.element(e.target).hasClass('froala-element')
                  ) {
                    if (scope.character.selected && scope.isFactSelected() && !scope.character.deleted) {
                      e.preventDefault();
                      scope.deleteCharacter();
                      scope.$apply();
                    }
                  }
                  break;
              }
            });

            element.find('.resize-anchor').bind('mousedown', function (e) {
              selectedAnchor = e.currentTarget;
              prevx = e.pageX;
              prevy = e.pageY;
              angular.element('body').bind('mousemove', resizeHandler);
            });

            element.find('.rotate-anchor').bind('mousedown', function (e) {
              action = 'rotate';
              var containerOffset = element.parent().parent().parent().parent();
              origin = {
                x: element[0].offsetLeft + element[0].offsetWidth / 2,
                y: element[0].offsetTop + element[0].offsetHeight / 2,
              };
              mouseOffset = {
                x: containerOffset[0].offsetLeft,
                y: containerOffset[0].offsetTop,
              };
              selectedAnchor = e.currentTarget;
              prevx = e.pageX;
              prevy = e.pageY;
              rotation = 0;
              element[0].style.zIndex = scope.character.character_z;
              angular.element('body').bind('mousemove', rotateHandler);
            });
          }
        }

        function determineToolPosition() {
          var toolWrapper = element.find('.fact-editor-tools-wrapper');

          var top = parseFloat(element[0].style.top) / 100;
          var left = parseFloat(element[0].style.left) / 100;

          if (top * container.height() - 50 < 0) {
            toolWrapper.css({
              top: -50 - (top * container.height() - 50) + 'px',
            });
          } else {
            toolWrapper.css({ top: '-50px' });
          }

          var width = toolWrapper.width() + 15;

          if (left * container.width() > container.width() - width) {
            //toolWrapper.css({left: ((left * container.width()) * -1) + 'px'});
            toolWrapper.css({
              left: -width + container.width() - left * container.width() + 'px',
            });
          } else {
            toolWrapper.css({ left: '0px' });
          }
        }

        scope.determineToolPosition = determineToolPosition;

        determineToolPosition();
      },
    };
  },
]);
